import { render, staticRenderFns } from "./ResetPasswordV1.vue?vue&type=template&id=3d81ca2e"
import script from "./ResetPasswordV1.vue?vue&type=script&lang=js"
export * from "./ResetPasswordV1.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordV1.vue?vue&type=style&index=0&id=3d81ca2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports